/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReRateServiceCompleteResponse
 */
export interface ReRateServiceCompleteResponse {
    /**
     * 
     * @type {string}
     * @memberof ReRateServiceCompleteResponse
     */
    reRateId?: string | null;
}

/**
 * Check if a given object implements the ReRateServiceCompleteResponse interface.
 */
export function instanceOfReRateServiceCompleteResponse(value: object): value is ReRateServiceCompleteResponse {
    return true;
}

export function ReRateServiceCompleteResponseFromJSON(json: any): ReRateServiceCompleteResponse {
    return ReRateServiceCompleteResponseFromJSONTyped(json, false);
}

export function ReRateServiceCompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReRateServiceCompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reRateId': json['reRateId'] == null ? undefined : json['reRateId'],
    };
}

export function ReRateServiceCompleteResponseToJSON(json: any): ReRateServiceCompleteResponse {
    return ReRateServiceCompleteResponseToJSONTyped(json, false);
}

export function ReRateServiceCompleteResponseToJSONTyped(value?: ReRateServiceCompleteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reRateId': value['reRateId'],
    };
}

